import { booleanParser, numberParser } from '../inboundParsers';
export const STAND_UP_INBOUND_DEFINITION = {
    definitionParts: [
        { name: 'isSelfStandingUp', parser: booleanParser },
        { name: 'playerId', parser: numberParser },
        { name: 'showBustedAnimation', parser: booleanParser }
    ]
};
